<script>
  import EditItemDialog from './dialogs/builder/EditItemDialog.svelte';
  import DeleteItemDialog from './dialogs/builder/DeleteItemDialog.svelte';
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  export let dataItem;
  export let mobile = false;
  const editGridItem = () => {
    dataItem.edit = true;
    mobile == true ? (dataItem.device = 'mobile') : (dataItem.device = 'desktop');
    dispatch('edit', dataItem);
  };
  const deleteGridItem = () => {
    dataItem.delete = true;
    mobile == true ? (dataItem.device = 'mobile') : (dataItem.device = 'desktop');
    dispatch('delete', dataItem);
  };
</script>

<div class="grid-item">
  <header>
    <p class="id">
      {dataItem.data.title || dataItem.data.collection}
      {#if dataItem.data.num_products === 12}
        <span>(Carousel)</span>
      {/if}
    </p>
    <!-- <p class="id">{dataItem.id}</p> -->
    <span on:pointerdown={(e) => e.stopPropagation()} class="remove">
      <EditItemDialog data={dataItem} on:submit={editGridItem} />
      <DeleteItemDialog data={dataItem} on:submit={deleteGridItem} />
    </span>
  </header>
  <div class="grid-item-content">
    {#if dataItem.data.image_url}
      <img src={dataItem.data.image_url} alt="" />
    {/if}
  </div>
</div>

<style>.grid-item{background:#fff;border:1px solid #efefef;border-radius:2px;box-sizing:border-box;height:100%;overflow:hidden;padding:1em;width:100%}.remove{cursor:pointer;display:flex;font-size:1em;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}header{display:flex;justify-content:space-between;width:100%}.id{cursor:pointer;font-size:1.2em;margin:0;text-transform:capitalize;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.id span{display:inline-block;font-size:12px;transform:translateY(-4px)}img{height:auto;max-width:100%;-o-object-fit:contain;object-fit:contain}</style>
